import { useEffect, useRef, useState, useCallback } from 'react';

export function useReveal(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  const onIntersect = useCallback((entries: IntersectionObserverEntry[]) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setVisible(true);
      }
    });
  }, []);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    const observer = new IntersectionObserver(onIntersect, { threshold });
    observer.observe(node);
    return () => observer.disconnect();
  }, [onIntersect, threshold]);

  return { ref, visible };
}